<template>
  <div>
    <div class="home-tab-content">
    <div class="mx-auto bg-white flex items-center gap-3 px-4 py-3">
      <div class="circle-img" :class="{ 'home-skeleton-group': pageLoading }">
        <div v-if="pageLoading" class="skeleton-block skeleton-circle" aria-hidden="true"></div>
        <img v-else :src="get_user_image()" style="width: 100%;"/>
      </div>
      <div class="user-info">
        <div class="text-sm" style="white-space: nowrap;">{{ user_name }}</div>
        <div v-if="user_mobile" class="text-xs">{{ user_mobile }}</div>
      </div>
      <div class="flex-grow"></div>
      <div class="border border-gray-500 rounded-md py-1 px-2 " v-if="branch_name">
        <div class="text-sm">{{ branch_name }}</div>
      </div>
    </div>


    

    <div class="pb-14 overflow-auto h-full pt-4 bg-gray-100 mx-auto w-full" style="height: 100vh;">
            <div
              v-if="pageLoading && $i18n.locale=='fa'"
              class="home-skeleton-group grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 px-4"
              aria-hidden="true"
            >
              <div
                v-for="n in skeletonMenuCount"
                :key="'home-sk-menu-' + n"
                class="skeleton-block skeleton-card"
              ></div>
              <div class="skeleton-block skeleton-work-btn col-span-2 sm:col-span-2"></div>
            </div>
            <div v-else-if="$i18n.locale=='fa'" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 px-4">
              <div v-if="accept_add_request" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow" v-on:click="go_to_customer_info(false)">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">ثبت در شعبه
                  <p class="text-xs text-gray-500 hidden lg:block mt-1">ثبت درخواست در شعبه</p>
                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/building-4.svg"/>
                </div>
              </div>
              <div v-if="accept_add_request" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow" v-on:click="go_to_customer_info(true)">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">ثبت در محل
                  <p class="text-xs text-gray-500 hidden lg:block mt-1">ثبت درخواست در محل مشتری</p>
                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/house.svg"/>
                </div>
              </div>
              <div v-on:click="go_to_referred_requests" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow relative">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">ارجاعیات به شما
                <p class="text-xs text-gray-500 hidden lg:block mt-1">درخواست‌های ارجاع داده شده</p>
                  </span>
                  <div class="relative flex-shrink-0">
                    <img class="w-10" src="../../../public/img/home-icon/clipboard-import(1).svg"/>
                    <span
                      v-if="referCount > 0"
                      class="absolute -top-2 -right-2 z-10 bg-red-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center shadow"
                      style="background-color: #ff1616;"
                    >
                      {{ referCountLabel }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">شکایات
                <p class="text-xs text-gray-500 hidden lg:block mt-1">ثبت و مدیریت شکایات</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/security.svg"/>
                </div>
              </div>
              <div v-if="accept_device" v-on:click="go_to_safir_devices()" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">تحویلی سفیر
                <p class="text-xs text-gray-500 hidden lg:block mt-1">مدیریت دستگاه‌های تحویلی</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/truck-tick.svg"/>
                </div>
              </div>
              <div v-on:click="go_to_report_referred_requests" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">گزارش ارجاعات
                <p class="text-xs text-gray-500 hidden lg:block mt-1">گزارش درخواست‌های ارجاعی</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/chart-21.svg"/>
                </div>
              </div>
              <div v-if="accept_all_request" v-on:click="go_to_search_all_requests" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">کل درخواست ها
                <p class="text-xs text-gray-500 hidden lg:block mt-1">مشاهده تمام درخواست‌ها</p>

                  </span>
                  <img class="w-9" src="../../../public/img/home-icon/task-square(1).svg"/>
                </div>
              </div>
              <div v-on:click="go_to_product_requests" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">سفارش کالا
                <p class="text-xs text-gray-500 hidden lg:block mt-1">ثبت و مدیریت سفارش کالا</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/bag(1).svg"/>
                </div>
              </div>
              <div v-on:click="go_to_buy_orders" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">سفارش خرید
                <p class="text-xs text-gray-500 hidden lg:block mt-1">ثبت و پیگیری سفارش خرید</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/truck-time(1).svg"/>
                </div>
              </div>
              <div v-if="accounting_report" v-on:click="go_to_accounting_report" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">گزارش های مالی
                <p class="text-xs text-gray-500 hidden lg:block mt-1">گزارش‌های مالی سیستم</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/money.svg"/>
                </div>
              </div>
              <div v-on:click="go_to_morakhasi" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">مرخصی ها
                <p class="text-xs text-gray-500 hidden lg:block mt-1">ثبت و مدیریت مرخصی</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/microscope.svg"/>
                </div>
              </div>
              <div v-on:click="go_to_pay_report" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">گزارش مالی درخواست ها
                <p class="text-xs text-gray-500 hidden lg:block mt-1">گزارش مالی درخواست‌ها</p>

                  </span>
                  <img class="w-9" src="../../../public/img/home-icon/diagram.svg"/>
                </div>
              </div>
              <div v-on:click="go_to_wallet" class="cursor-pointer flex flex-col bg-white rounded-xl p-4 border border-gray-200 hover:shadow-md transition-shadow">
                <div class="flex justify-between items-center gap-2">
                  <span class="text-sm font-medium">کیف پول
                <p class="text-xs text-gray-500 hidden lg:block mt-1">مشاهده موجودی کیف پول</p>

                  </span>
                  <img class="w-10" src="../../../public/img/home-icon/wallet.svg"/>
                </div>
              </div>

               <!-- شروع به کار / پایان کار -->
               <div v-if="!is_work_started" v-on:click="startWork" class="home-work-btn flex mt-3 col-span-2 sm:col-span-2 self-start relative justify-center items-center gap-4 bg-blue-700 rounded-full py-3 pr-8 pl-4 cursor-pointer hover:bg-blue-800 transition-colors">
                 <span class="text-md text-white font-semibold">شروع به کار</span>
                 <img class="w-8 bg-white rounded-full p-1.5 absolute left-4" src="../../../public/img/home-icon/play-circle.svg"/>
               </div>
               <div v-if="is_work_started" v-on:click="endWork" class="home-work-btn home-work-btn--active flex mt-3 col-span-2 sm:col-span-2 self-start relative justify-center items-center gap-4 bg-navy rounded-full py-3 pr-14 pl-5 cursor-pointer hover:bg-gray-800 transition-colors">
                 <div class="flex flex-col items-start text-right min-w-0">
                   <span class="text-md text-white font-semibold leading-tight">پایان کار</span>
                   <span v-if="work_until_label || work_remaining_label" class="text-xs text-slate-300 mt-0.5 leading-tight truncate">
                     <template v-if="work_until_label && work_remaining_label">{{ work_until_label }} - {{ work_remaining_label }}</template>
                     <template v-else>{{ work_until_label || work_remaining_label }}</template>
                   </span>
                 </div>
                 <img class="w-8 bg-white rounded-full p-1.5 absolute left-4" src="../../../public/img/home-icon/pause-circle.svg"/>
               </div>

              
              <!-- <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(false)">
                <img class="w-full" src="../../../public/img/sabt_dar_shobe.png"/>
              </div>
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(true)">
                <img class="w-full" src="../../../public/img/sabt_dar_mahal.png"/>
              </div> -->
              <!-- <div class="flex justify-center" v-on:click="go_to_referred_requests">
                <img class="w-full" src="../../../public/img/my_refers.png"/>
              </div> -->
              <!-- <div class="flex justify-center">
                <img class="w-full" src="../../../public/img/shekaiat_logo.png"/>
              </div> -->
              <!-- <div v-if="accept_device" class="flex justify-center" v-on:click="go_to_safir_devices()">
                <img class="w-full" src="../../../public/img/safir_logo.png"/>
              </div> -->
              <!-- <div class="flex justify-center" v-on:click="go_to_report_referred_requests">
                <img class="w-full" src="../../../public/img/report_refered_request.png"/>
              </div> -->
              <!-- <div v-if="accept_all_request" class="flex justify-center" v-on:click="go_to_search_all_requests">
                <img class="w-full" src="/img/AllRequests.png"/>
              </div> -->
              <!-- <div class="flex justify-center" v-on:click="go_to_product_requests">
                <img class="w-full" src="/img/product_request.png"/>
              </div> -->
              <!-- <div class="flex justify-center" v-on:click="go_to_buy_orders">
                <img class="w-full" src="/img/buy_orders.png"/>
              </div> -->
              <!-- <div v-if="accounting_report" class="flex justify-center" v-on:click="go_to_accounting_report">
                <img class="w-full" src="/img/AccountingReport.png"/>
              </div> -->
              <!-- <div class="flex justify-center" v-on:click="go_to_morakhasi">
                <img class="w-full" src="/img/morakhasi.png"/>
              </div> -->
              <!-- <div class="flex justify-center" v-on:click="go_to_pay_report">
                <img class="w-full" src="/img/request_accounting_report.png"/>
              </div> -->
            </div>

            <div
              v-if="pageLoading && $i18n.locale=='en'"
              class="home-skeleton-group grid grid-cols-2 gap-4 px-4"
              aria-hidden="true"
            >
              <div
                v-for="n in skeletonMenuCountEn"
                :key="'home-sk-menu-en-' + n"
                class="skeleton-block skeleton-card-en"
              ></div>
            </div>
            <div v-else-if="$i18n.locale=='en'" class="grid grid-cols-2 gap-4 px-4">
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(false)">
                <img class="w-full" src="/img/sabt_dar_shobe_tr.png"/>
              </div>
              <div v-if="accept_add_request" class="flex justify-center" v-on:click="go_to_customer_info(true)">
                <img class="w-full" src="/img/sabt_dar_mahal_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_referred_requests">
                <img class="w-full" src="/img/my_refers_tr.png"/>
              </div>
              <div class="flex justify-center">
                <img class="w-full" src="/img/shekaiat_logo_tr.png"/>
              </div>
              <div v-if="accept_device" class="flex justify-center" v-on:click="go_to_safir_devices()">
                <img class="w-full" src="/img/safir_logo_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_report_referred_requests">
                <img class="w-full" src="/img/report_refered_request_tr.png"/>
              </div>
              <div v-if="accept_all_request" class="flex justify-center" v-on:click="go_to_search_all_requests">
                <img class="w-full" src="/img/AllRequests_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_product_requests">
                <img class="w-full" src="/img/product_request_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_buy_orders">
                <img class="w-full" src="/img/buy_orders_tr.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_accounting_report">
                <img class="w-full" src="/img/AccountingReport.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_morakhasi">
                <img class="w-full" src="/img/morakhasi.png"/>
              </div>
              <div class="flex justify-center" v-on:click="go_to_pay_report">
                <img class="w-full" src="/img/request_accounting_report.png"/>
              </div>
            </div>
            <!-- Version display -->
            <div v-if="pageLoading" class="skeleton-block skeleton-version mx-auto mt-8 mb-4" aria-hidden="true"></div>
            <p v-else class="text-gray-400 text-xs mt-8 text-center w-full mx-auto pb-4">نسخه {{ version }}</p>
    </div>
    </div>
      <BottomNav v-model="tab">
      </BottomNav>

    <div class="start-conversation" v-on:click="goToReminder()">
      <img src="/img/svg/reminder.svg" alt="reminder" class="w-7 h-7">

    </div>

    <!-- Start Work Dialog -->
    <transition name="work-sheet">
    <div v-if="work_dialog_open" class="work-dialog fixed left-0 right-0" :style="workDialogOverlayStyle" dir="rtl">
      <div class="work-dialog__backdrop absolute inset-0" @click="closeWorkDialog"></div>
      <div class="relative z-10 flex h-full w-full items-center justify-center p-4">
        <div class="work-dialog__panel w-full max-w-md bg-white rounded-2xl sm:rounded-3xl shadow-2xl flex flex-col">
          <div class="work-dialog__header relative px-5 pt-4 pb-5 flex-shrink-0">
            <button
              type="button"
              @click="closeWorkDialog"
              class="absolute top-3 left-4 sm:top-4 w-9 h-9 flex items-center justify-center rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white transition-colors"
              aria-label="بستن"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div class="flex items-center gap-3">
              <div class="work-dialog__icon flex-shrink-0 w-12 h-12 rounded-2xl bg-white bg-opacity-20 flex items-center justify-center">
                <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div class="min-w-0 w-full text-right">
                <h3 class="text-lg font-bold text-white leading-tight">شروع به کار</h3>
                <p class="text-sm text-blue-100 mt-0.5 leading-snug">لطفاً بازه زمانی حضور خود را مشخص کنید</p>
              </div>
            </div>
          </div>

          <div class="work-dialog__body px-5 py-5 space-y-4 flex-1 min-h-0">
            <div class="grid grid-cols-2 gap-3">
              <div class="work-dialog__field">
                <div class="work-dialog__field-label">
                  <svg class="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>از ساعت</span>
                </div>
                <div class="work-time-row">
                  <div class="work-time-dd" :class="{ 'is-open': work_time_menu === 'from-hour' }">
                    <button type="button" class="work-time-dd__btn" @click.stop="toggleWorkTimeMenu('from-hour')">
                      <span class="work-time-dd__value" :class="{ 'is-placeholder': !work_from_hour }">{{ work_from_hour || 'ساعت' }}</span>
                      <span class="work-time-dd__icon" aria-hidden="true"></span>
                    </button>
                    <div v-if="work_time_menu === 'from-hour'" class="work-time-dd__menu">
                      <button
                        v-for="h in workHourOptions"
                        :key="'from-h-' + h"
                        type="button"
                        class="work-time-dd__option"
                        :class="{ 'is-active': work_from_hour === h }"
                        @click.stop="selectWorkTimePart('from', 'hour', h)"
                      >{{ h }}</button>
                    </div>
                  </div>
                  <span class="work-time-sep">:</span>
                  <div class="work-time-dd" :class="{ 'is-open': work_time_menu === 'from-minute' }">
                    <button type="button" class="work-time-dd__btn" @click.stop="toggleWorkTimeMenu('from-minute')">
                      <span class="work-time-dd__value" :class="{ 'is-placeholder': !work_from_minute }">{{ work_from_minute || 'دقیقه' }}</span>
                      <span class="work-time-dd__icon" aria-hidden="true"></span>
                    </button>
                    <div v-if="work_time_menu === 'from-minute'" class="work-time-dd__menu">
                      <button
                        v-for="m in workMinuteOptions"
                        :key="'from-m-' + m"
                        type="button"
                        class="work-time-dd__option"
                        :class="{ 'is-active': work_from_minute === m }"
                        @click.stop="selectWorkTimePart('from', 'minute', m)"
                      >{{ m }}</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="work-dialog__field">
                <div class="work-dialog__field-label">
                  <svg class="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>تا ساعت</span>
                </div>
                <div class="work-time-row">
                  <div class="work-time-dd" :class="{ 'is-open': work_time_menu === 'to-hour' }">
                    <button type="button" class="work-time-dd__btn" @click.stop="toggleWorkTimeMenu('to-hour')">
                      <span class="work-time-dd__value" :class="{ 'is-placeholder': !work_to_hour }">{{ work_to_hour || 'ساعت' }}</span>
                      <span class="work-time-dd__icon" aria-hidden="true"></span>
                    </button>
                    <div v-if="work_time_menu === 'to-hour'" class="work-time-dd__menu">
                      <button
                        v-for="h in workToHourOptions"
                        :key="'to-h-' + h"
                        type="button"
                        class="work-time-dd__option"
                        :class="{ 'is-active': work_to_hour === h }"
                        @click.stop="selectWorkTimePart('to', 'hour', h)"
                      >{{ h }}</button>
                    </div>
                  </div>
                  <span class="work-time-sep">:</span>
                  <div class="work-time-dd" :class="{ 'is-open': work_time_menu === 'to-minute' }">
                    <button type="button" class="work-time-dd__btn" @click.stop="toggleWorkTimeMenu('to-minute')">
                      <span class="work-time-dd__value" :class="{ 'is-placeholder': !work_to_minute }">{{ work_to_minute || 'دقیقه' }}</span>
                      <span class="work-time-dd__icon" aria-hidden="true"></span>
                    </button>
                    <div v-if="work_time_menu === 'to-minute'" class="work-time-dd__menu">
                      <button
                        v-for="m in workToMinuteOptions"
                        :key="'to-m-' + m"
                        type="button"
                        class="work-time-dd__option"
                        :class="{ 'is-active': work_to_minute === m }"
                        @click.stop="selectWorkTimePart('to', 'minute', m)"
                      >{{ m }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="work-dialog__field work-dialog__field--full">
              <div class="work-dialog__field-label">
                <svg class="w-3.5 h-3.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h10M4 18h14" />
                </svg>
                <span>توضیحات</span>
                <span class="text-gray-400 font-normal mr-auto">اختیاری</span>
              </div>
              <textarea
                v-model="work_desc"
                rows="3"
                placeholder="در صورت نیاز توضیحی بنویسید..."
                class="work-dialog__textarea"
                @focus="onWorkDialogInputFocus"
              ></textarea>
            </div>
          </div>

          <div class="work-dialog__actions px-5 pb-5 pt-2 flex flex-col gap-2 flex-shrink-0">
            <button
              type="button"
              @click="confirmStartWork"
              :disabled="work_submitting"
              class="work-dialog__submit w-full py-3.5 text-white rounded-2xl text-sm font-bold transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <span v-if="work_submitting" class="inline-flex items-center justify-center gap-2">
                <span class="work-dialog__spinner"></span>
                در حال ثبت...
              </span>
              <span v-else>تایید و شروع کار</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    </transition>

    <!-- End Work Confirm Dialog -->
    <transition name="work-sheet">
    <div v-if="end_work_dialog_open" class="work-dialog fixed left-0 right-0" :style="workDialogOverlayStyle" dir="rtl">
      <div class="work-dialog__backdrop absolute inset-0" @click="closeEndWorkDialog"></div>
      <div class="relative z-10 flex h-full w-full items-center justify-center p-4">
        <div class="work-dialog__panel w-full max-w-md bg-white rounded-2xl sm:rounded-3xl shadow-2xl flex flex-col">
          <div class="work-dialog__header relative px-5 pt-4 pb-5 flex-shrink-0">
            <button
              type="button"
              @click="closeEndWorkDialog"
              class="absolute top-3 left-4 sm:top-4 w-9 h-9 flex items-center justify-center rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white transition-colors"
              aria-label="بستن"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div class="flex items-center gap-3">
              <div class="work-dialog__icon flex-shrink-0 w-12 h-12 rounded-2xl bg-white bg-opacity-20 flex items-center justify-center">
                <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div class="min-w-0 w-full text-right">
                <h3 class="text-lg font-bold text-white leading-tight">پایان کار</h3>
                <p class="text-sm text-blue-100 mt-0.5 leading-snug">آیا از پایان کار مطمئن هستید؟</p>
              </div>
            </div>
          </div>

          <div class="work-dialog__body px-5 py-5 space-y-4 overflow-y-auto flex-1 min-h-0">
            <div class="work-dialog__field work-dialog__field--full">
              <p class="text-sm text-gray-600 leading-relaxed text-center">
                با تأیید، وضعیت کاری شما به پایان‌یافته تغییر می‌کند.
              </p>
            </div>
          </div>

          <div class="work-dialog__actions px-5 pb-5 pt-2 flex flex-col gap-2 flex-shrink-0">
            <button
              type="button"
              @click="confirmEndWork"
              :disabled="work_end_submitting"
              class="work-dialog__submit w-full py-3.5 text-white rounded-2xl text-sm font-bold transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <span v-if="work_end_submitting" class="inline-flex items-center justify-center gap-2">
                <span class="work-dialog__spinner"></span>
                در حال ثبت...
              </span>
              <span v-else>بله، پایان کار</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    </transition>
  </div>

</template>
<script>
  import {bus} from '../../main.js'
  import BottomNav from '../../components/BottomNav.vue'
  import { fetchServerVersion } from '../../utils/versionChecker'

  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  const homeSilentRequest = skeletonSilentRequest

  function buildNumberOptions(count) {
    const options = []
    for (let i = 0; i < count; i++) {
      options.push(String(i).padStart(2, '0'))
    }
    return options
  }

  export default {
    components: {
      BottomNav,
    },
    data() {
      return {
        tab: null,
        branch_name:localStorage.getItem("branch_name"),
        user_name: (JSON.parse(localStorage.getItem('profile')) || {}).UserName || '',
        user_mobile: (localStorage.getItem('phone') || '').replace('+98',''),
        app_version: process.env.VUE_APP_VERSION_CODE,
        accept_device: false,
        accept_add_request: false,
        accept_all_request: false,
        accounting_report: false,
        is_work_started: localStorage.getItem('is_work_started') === '1',
        work_dialog_open: false,
        end_work_dialog_open: false,
        work_from_hour: '',
        work_from_minute: '',
        work_to_hour: '',
        work_to_minute: '',
        work_time_menu: '',
        work_desc: '',
        work_submitting: false,
        work_end_submitting: false,
        work_until_label: '',
        work_remaining_label: '',
        work_end_time: '',
        workHourOptions: buildNumberOptions(24),
        workMinuteOptions: buildNumberOptions(60),
        version: '',
        referCount: 0, // تعداد درخواست‌های ارجاعی
        pageLoading: true,
        skeletonMenuCount: 13,
        skeletonMenuCountEn: 12,
        viewport_height: typeof window !== 'undefined' ? window.innerHeight : null,
        viewport_offset_top: 0,
      }
    },
    computed: {
      referCountLabel() {
        const n = this.referCount > 99 ? 99 : this.referCount
        const fa = String(n).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
        return this.referCount > 99 ? fa + '+' : fa
      },
      workDialogOverlayStyle() {
        const height = this.viewport_height != null ? this.viewport_height : (typeof window !== 'undefined' ? window.innerHeight : 0)
        return {
          zIndex: 999,
          top: (this.viewport_offset_top || 0) + 'px',
          height: height + 'px',
          bottom: 'auto',
        }
      },
      isAnyWorkDialogOpen() {
        return this.work_dialog_open || this.end_work_dialog_open
      },
      work_from_time() {
        if (this.work_from_hour === '' || this.work_from_minute === '') return ''
        return this.work_from_hour + ':' + this.work_from_minute
      },
      work_to_time() {
        if (this.work_to_hour === '' || this.work_to_minute === '') return ''
        return this.work_to_hour + ':' + this.work_to_minute
      },
      workToHourOptions() {
        if (this.work_from_hour === '') return this.workHourOptions
        const fromHour = parseInt(this.work_from_hour, 10)
        const fromMinute = this.work_from_minute === '' ? -1 : parseInt(this.work_from_minute, 10)
        return this.workHourOptions.filter((h) => {
          const hour = parseInt(h, 10)
          if (hour > fromHour) return true
          // اگر همان ساعت باشد، فقط وقتی دقیقه از هنوز انتخاب نشده یا دقیقه قابل‌انتخاب باقی مانده باشد
          if (hour === fromHour) {
            if (fromMinute < 0) return true
            return fromMinute < 59
          }
          return false
        })
      },
      workToMinuteOptions() {
        if (this.work_to_hour === '') return this.workMinuteOptions
        if (this.work_from_hour === '' || this.work_from_minute === '') return this.workMinuteOptions

        const fromHour = parseInt(this.work_from_hour, 10)
        const fromMinute = parseInt(this.work_from_minute, 10)
        const toHour = parseInt(this.work_to_hour, 10)

        if (toHour > fromHour) return this.workMinuteOptions
        if (toHour < fromHour) return []
        return this.workMinuteOptions.filter((m) => parseInt(m, 10) > fromMinute)
      },
    },
    watch: {
      isAnyWorkDialogOpen: {
        immediate: true,
        handler(open) {
          if (typeof document === 'undefined') return
          document.body.classList.toggle('work-dialog-open', !!open)
        },
      },
      work_from_hour() {
        this.sanitizeWorkToTime()
      },
      work_from_minute() {
        this.sanitizeWorkToTime()
      },
      work_to_hour() {
        this.sanitizeWorkToTime()
      },
    },
    async mounted() {
      try {
        await this.initHomePage()
      } finally {
        this.pageLoading = false
      }

      this.bindWorkDialogViewport()
      this.bindWorkTimeMenuOutside()
      this.config_firebase();
      this.technician_login()
      Notification.requestPermission(permission => {
        if (permission === 'granted') {
          this.registerBackgroundSync()
        } else console.error("Permission was not granted.")
      })
    },
    beforeDestroy() {
      this.unbindWorkDialogViewport()
      this.unbindWorkTimeMenuOutside()
      if (typeof document !== 'undefined') {
        document.body.classList.remove('work-dialog-open')
      }
    },
    methods: {
      async initHomePage() {
        const serverVersion = await fetchServerVersion()
        this.version = serverVersion || 'N/A'

        await Promise.allSettled([
          this.check_accept_device(),
          this.check_ZkCheckManageReport(),
          this.check_add_request(),
          this.check_all_request(),
          this.check_user_in_zoodkomak(),
          this.check_technician_ready(),
        ])
      },
      registerBackgroundSync() {
        if (!navigator.serviceWorker) {
          return console.error("Service Worker not supported")
        }

        navigator.serviceWorker.ready
          .then(registration => registration.sync.register('syncAttendees'))
          .then(() => console.log("Registered background sync"))
          .catch(err => console.error("Error registering background sync", err))
      },
      goToReminder() {
        this.$router.push({name: 'ReminderList', params: {}})
      },
      bindWorkDialogViewport() {
        this._onWorkDialogViewportChange = () => {
          if (window.visualViewport) {
            this.viewport_height = window.visualViewport.height
            this.viewport_offset_top = window.visualViewport.offsetTop
          } else {
            this.viewport_height = window.innerHeight
            this.viewport_offset_top = 0
          }
        }
        this._onWorkDialogViewportChange()
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', this._onWorkDialogViewportChange)
          window.visualViewport.addEventListener('scroll', this._onWorkDialogViewportChange)
        }
        window.addEventListener('resize', this._onWorkDialogViewportChange)
      },
      unbindWorkDialogViewport() {
        if (window.visualViewport && this._onWorkDialogViewportChange) {
          window.visualViewport.removeEventListener('resize', this._onWorkDialogViewportChange)
          window.visualViewport.removeEventListener('scroll', this._onWorkDialogViewportChange)
        }
        if (this._onWorkDialogViewportChange) {
          window.removeEventListener('resize', this._onWorkDialogViewportChange)
        }
      },
      onWorkDialogInputFocus() {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this._onWorkDialogViewportChange) this._onWorkDialogViewportChange()
            const actions = this.$el && this.$el.querySelector('.work-dialog__actions')
            if (actions && typeof actions.scrollIntoView === 'function') {
              actions.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
            }
          }, 300)
        })
      },
      startWork() {
        const now = new Date()
        this.work_from_hour = String(now.getHours()).padStart(2, '0')
        this.work_from_minute = '00'
        this.work_to_hour = ''
        this.work_to_minute = '00'
        this.work_time_menu = ''
        this.work_desc = ''
        this.work_dialog_open = true
        this.$nextTick(() => {
          if (this._onWorkDialogViewportChange) this._onWorkDialogViewportChange()
        })
      },
      toggleWorkTimeMenu(menu) {
        this.work_time_menu = this.work_time_menu === menu ? '' : menu
      },
      selectWorkTimePart(which, part, value) {
        if (which === 'from' && part === 'hour') this.work_from_hour = value
        if (which === 'from' && part === 'minute') this.work_from_minute = value
        if (which === 'to' && part === 'hour') this.work_to_hour = value
        if (which === 'to' && part === 'minute') this.work_to_minute = value
        this.work_time_menu = ''
        this.$nextTick(() => this.sanitizeWorkToTime())
      },
      sanitizeWorkToTime() {
        if (this.work_to_hour !== '' && this.workToHourOptions.indexOf(this.work_to_hour) === -1) {
          this.work_to_hour = ''
          this.work_to_minute = ''
          return
        }
        if (this.work_to_minute !== '' && this.workToMinuteOptions.indexOf(this.work_to_minute) === -1) {
          this.work_to_minute = ''
        }
      },
      bindWorkTimeMenuOutside() {
        this._onWorkTimeMenuOutside = () => {
          this.work_time_menu = ''
        }
        document.addEventListener('click', this._onWorkTimeMenuOutside)
      },
      unbindWorkTimeMenuOutside() {
        if (this._onWorkTimeMenuOutside) {
          document.removeEventListener('click', this._onWorkTimeMenuOutside)
        }
      },
      closeWorkDialog() {
        if (this.work_submitting) return
        this.work_time_menu = ''
        this.work_dialog_open = false
      },
      formatTimeForApi(timeValue) {
        if (!timeValue) return ''
        const parts = String(timeValue).split(':')
        const hh = (parts[0] || '00').padStart(2, '0')
        const mm = (parts[1] || '00').padStart(2, '0')
        const ss = (parts[2] || '00').padStart(2, '0')
        return hh + ':' + mm + ':' + ss
      },
      confirmStartWork() {
        if (!this.work_from_time || !this.work_to_time) {
          bus.$emit('show_toast', [2000, 'از ساعت و تا ساعت را وارد کنید'])
          return
        }
        if (this.work_submitting) return

        var user_id = null
        try {
          user_id = (JSON.parse(localStorage.getItem('profile')) || {}).UserId
        } catch (e) {
          user_id = null
        }

        const send_data = {
          UserId: user_id,
          RecDesc: this.work_desc || '',
          fromDate: this.formatTimeForApi(this.work_from_time),
          toDate: this.formatTimeForApi(this.work_to_time),
        }

        this.work_submitting = true
        this.axios.post('/AddTechnicianReady', send_data, {})
          .then(response => {
            if (response.data && response.data.error == 0) {
              this.is_work_started = true
              localStorage.setItem('is_work_started', '1')
              this.applyWorkReadyInfo(this.work_to_time)
              this.work_dialog_open = false
              bus.$emit('show_toast', [2000, response.data.msg || 'شروع به کار ثبت شد'])
            } else {
              bus.$emit('show_toast', [2500, (response.data && response.data.msg) || 'خطا در ثبت شروع به کار'])
            }
          })
          .catch(() => {
            bus.$emit('show_toast', [2500, 'خطا در ارتباط با سرور'])
          })
          .finally(() => {
            this.work_submitting = false
          })
      },
      endWork() {
        this.end_work_dialog_open = true
        this.$nextTick(() => {
          if (this._onWorkDialogViewportChange) this._onWorkDialogViewportChange()
        })
      },
      closeEndWorkDialog() {
        if (this.work_end_submitting) return
        this.end_work_dialog_open = false
      },
      confirmEndWork() {
        if (this.work_end_submitting) return

        var user_id = null
        try {
          user_id = (JSON.parse(localStorage.getItem('profile')) || {}).UserId
        } catch (e) {
          user_id = null
        }

        const now = new Date()
        const nowTime =
          String(now.getHours()).padStart(2, '0') + ':' +
          String(now.getMinutes()).padStart(2, '0') + ':' +
          String(now.getSeconds()).padStart(2, '0')

        const send_data = {
          UserId: user_id,
          RecDesc: '',
          fromDate: nowTime,
          toDate: nowTime,
        }

        this.work_end_submitting = true
        this.axios.post('/AddTechnicianReady', send_data, {})
          .then(response => {
            if (response.data && response.data.error == 0) {
              this.is_work_started = false
              localStorage.setItem('is_work_started', '0')
              this.clearWorkReadyInfo()
              this.end_work_dialog_open = false
              bus.$emit('show_toast', [2000, response.data.msg || 'پایان کار ثبت شد'])
            } else {
              bus.$emit('show_toast', [2500, (response.data && response.data.msg) || 'خطا در ثبت پایان کار'])
            }
          })
          .catch(() => {
            bus.$emit('show_toast', [2500, 'خطا در ارتباط با سرور'])
          })
          .finally(() => {
            this.work_end_submitting = false
          })
      },
      config_firebase() {
        // var self = this;
        // try{
        //   this.$messaging.messaging.requestPermission().then(() => {
        //     console.log('Notification permission granted.');
        //
        //     // Get Token
        //     this.$messaging.db.app.messaging().getToken({vapidKey: "BP9_Qg8FqhjCVuttOnqcBmKnfE1Eu9m22xNb4dy8DEWKG90lDXN--n-ZCIoYgImZLe4oAGb-Iej0CD9rdvdzr-M"})
        //       .then((currentToken) => {
        //         if (currentToken) {
        //           console.log('client token', currentToken)
        //           self.send_token(currentToken);
        //           self.$messaging.messaging.onMessage((payload) => {
        //             console.log('Message received. ', payload);
        //             // ...
        //           });
        //           self.$messaging.db.app.messaging().onMessage((payload) => {
        //             console.log('Message received2. ', payload);
        //             // ...
        //           });
        //
        //         } else {
        //           console.log('No registration token available. Request permission to generate one.');
        //         }
        //       }).catch((err) => {
        //       console.log('An error occurred while retrieving token. ', err);
        //     })
        //   }).catch((err) => {
        //     console.log('Unable to get permission to notify.', err);
        //   });
        //
        // }catch (e) {
        //   console.log('error Request permission to generate one.',e);
        //
        // }
      },
      send_token(token) {
        console.log(localStorage.getItem('profile'))
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var device_id = JSON.parse(localStorage.getItem('profile')).UserDeviceNo

        const send_data = {
          UserId: user_id,
          DeviceId: device_id,
          Token: token,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/UpdateFirebaseToken', send_data, homeSilentRequest)
          .then(response => {
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      check_user_in_zoodkomak() {
        var user_name = JSON.parse(localStorage.getItem('profile')).UserName

        const send_data = {
          MobileNo: localStorage.getItem("phone").replace("+98", ""),
          Pass: localStorage.getItem("password"),
        }
        return this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, homeSilentRequest)
          .then(response => {
            var self = this
            localStorage.setItem('userId2', response.data.UserId)
            if (response.data && response.data.ImageUrl) {
              localStorage.setItem('ImageUrl', response.data.ImageUrl)
            }
            if (response.data && response.data.ReferCount !== undefined && response.data.ReferCount !== null) {
              self.referCount = parseInt(response.data.ReferCount, 10) || 0
            }

            var formData = new FormData();
            formData.append('UserName', user_name);
            formData.append('UserId', response.data.UserId);
            formData.append('MobileNo', localStorage.getItem("phone"));
            formData.append('Password', localStorage.getItem("password"));

            return this.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, homeSilentRequest)
          })
          .catch(e => {
            this.errors.push(e)
          })
      },
      go_to_customer_info(OnSite) {
        var PassingData = {on_site_service: OnSite}
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        // this.$store.commit('set', ['request_data', PassingData])
        // this.$store.commit('toggleSidebarDesktop')
        // console.log(store.state.count) //
        this.$router.push({name: 'CustomerInfo', params: {}})
      },
      go_to_referred_requests() {
        this.$router.push({name: 'ReferredRequest', params: {}})
      },
      go_to_morakhasi() {
        this.$router.push({name: 'MorakhasiList', params: {}})
      },
      go_to_pay_report() {
        this.$router.push({name: 'RequestPayReportList', params: {}})
      },
      go_to_wallet() {
        this.$router.push({name: 'Wallet', params: {}})
      },
      go_to_buy_orders() {
        this.$router.push({name: 'BuyOrdersList', params: {}})
      },
      go_to_report_referred_requests() {
        this.$router.push({name: 'ReportReferredRequest', params: {}})
      },
      go_to_search_all_requests() {
        this.$router.push({path: '/report-request/search-all-requests', params: {}})
      },
      go_to_safir_devices() {
        this.$router.push({name: 'SafirDevices', params: {}})
      },
      go_to_product_requests() {

        this.$router.push({name: 'ProductRequestFactors', params: {rec_id: 0}})
      },
      go_to_accounting_report() {

        this.$router.push({name: 'AccountingReport', params: {}})
      },
      check_accept_device() {
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        return this.axios.post('/CheckAcceptDevice', send_data, homeSilentRequest)
          .then(response => {
            this.accept_device = response.data.error == 0
          })
          .catch(e => {
            this.errors.push(e)
          })
      },
      check_technician_ready() {
        var user_id = null
        try {
          user_id = (JSON.parse(localStorage.getItem('profile')) || {}).UserId
        } catch (e) {
          user_id = null
        }
        if (!user_id) return Promise.resolve()

        return this.axios.post('/CheckExistsTechnicianReady', { UserId: user_id }, homeSilentRequest)
          .then(response => {
            const data = response.data || {}
            const isReady = Number(data.isReady)

            // اگر آماده نباشد، دکمه را روی «شروع به کار» بگذار
            if (isReady === 0) {
              this.is_work_started = false
              localStorage.setItem('is_work_started', '0')
              this.clearWorkReadyInfo()
              return
            }

            if (isReady === 1) {
              this.is_work_started = true
              localStorage.setItem('is_work_started', '1')
              this.applyWorkReadyInfo(data.msg)
              return
            }

            this.is_work_started = false
            localStorage.setItem('is_work_started', '0')
            this.clearWorkReadyInfo()
          })
          .catch(() => {})
      },
      parseReadyEndTime(msg) {
        if (!msg) return ''
        const match = String(msg).match(/تا\s+(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?/)
        if (!match) return ''
        const hh = String(match[1]).padStart(2, '0')
        const mm = String(match[2]).padStart(2, '0')
        return hh + ':' + mm
      },
      formatUntilDisplay(timeStr) {
        if (!timeStr) return ''
        const parts = String(timeStr).split(':')
        const hh = parseInt(parts[0], 10)
        const mm = parseInt(parts[1] || '0', 10)
        if (isNaN(hh)) return ''
        if (!mm) return 'تا ساعت ' + hh
        return 'تا ساعت ' + String(hh).padStart(2, '0') + ':' + String(mm).padStart(2, '0')
      },
      formatRemainingLabel(timeStr) {
        if (!timeStr) return ''
        const parts = String(timeStr).split(':')
        const hh = parseInt(parts[0], 10)
        const mm = parseInt(parts[1] || '0', 10)
        if (isNaN(hh) || isNaN(mm)) return ''

        const now = new Date()
        const end = new Date(now)
        end.setHours(hh, mm, 0, 0)

        let diffMs = end.getTime() - now.getTime()
        if (diffMs <= 0) return 'زمان به پایان رسیده'

        const totalMinutes = Math.floor(diffMs / 60000)
        const hours = Math.floor(totalMinutes / 60)
        const minutes = totalMinutes % 60

        if (hours > 0 && minutes > 0) return hours + ' ساعت و ' + minutes + ' دقیقه مانده'
        if (hours > 0) return hours + ' ساعت مانده'
        if (minutes > 0) return minutes + ' دقیقه مانده'
        return 'کمتر از یک دقیقه مانده'
      },
      applyWorkReadyInfo(msgOrEndTime) {
        let endTime = ''
        if (msgOrEndTime && String(msgOrEndTime).indexOf(':') > -1 && String(msgOrEndTime).indexOf('تا') === -1) {
          const parts = String(msgOrEndTime).split(':')
          endTime = String(parts[0]).padStart(2, '0') + ':' + String(parts[1] || '00').padStart(2, '0')
        } else {
          endTime = this.parseReadyEndTime(msgOrEndTime)
        }
        this.work_end_time = endTime
        this.work_until_label = this.formatUntilDisplay(endTime)
        this.work_remaining_label = this.formatRemainingLabel(endTime)
      },
      clearWorkReadyInfo() {
        this.work_end_time = ''
        this.work_until_label = ''
        this.work_remaining_label = ''
      },
      check_ZkCheckManageReport() {
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
          Role: "CheckManageReport",
        }
        return this.axios.post('/ZkGetUserPermission', send_data, homeSilentRequest)
          .then(response => {
            this.accounting_report = !!response.data.UserAllow
          })
          .catch(e => {
            this.errors.push(e)
          })
      },
      check_add_request() {
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        return this.axios.post('/CheckCustomerRequest', send_data, homeSilentRequest)
          .then(response => {
            this.accept_add_request = response.data.error == 0
          })
          .catch(e => {
            this.errors.push(e)
          })
      },
      check_all_request() {
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          PartyId: party_id,
        }
        return this.axios.post('/CheckSysAllReqs', send_data, homeSilentRequest)
          .then(response => {
            this.accept_all_request = response.data.error == 0
          })
          .catch(e => {
            this.errors.push(e)
          })
      },
      technician_login() {
        var self = this
        var eddited_mobile = localStorage.getItem('phone')
        var password = localStorage.getItem('password')

        const send_data = {
          MobileNo: eddited_mobile,
          Password: password,
          "OsName": "PWA",
          "AppNo": "4",
          "OsVersion": "1",
          DeviceModel: 'android',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/TechnicianLogin', send_data, homeSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              localStorage.setItem("PrivateCall", response.data.newVersion.PrivateCall);

              console.log('version is ', self.app_version, response.data.newVersion.VersionCode)
              if (self.app_version < response.data.newVersion.VersionCode) {
                if ('serviceWorker' in navigator) {
                  caches.keys().then(function (cacheNames) {
                    cacheNames.forEach(function (cacheName) {
                      caches.delete(cacheName);
                    });
                  });
                }
                window.location.reload(true)

              }
            } else {
              localStorage.setItem('profile', '')
              localStorage.setItem('phone', '')
              localStorage.setItem('password', '')
              localStorage.setItem('party_id', '')
              self.$router.push({name: 'login', params: {}})

              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          // this.errors.push(e);
          // bus.$emit('show_toast', [2000, e])

        })
      },

    }
  }
</script>
<style scoped>
  .circle-img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #e5e7eb;
  }

  .user-info {
    flex: 1;
  }

  .home-tab-content {
    min-height: 0;
  }

  .work-time-row {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    direction: ltr;
    width: 100%;
  }

  .work-time-sep {
    flex: 0 0 auto;
    font-size: 1rem;
    font-weight: 700;
    color: #64748b;
    line-height: 1;
    padding: 0 0.1rem;
  }

  .work-time-dd {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
  }

  .work-time-dd__btn {
    position: relative;
    display: block;
    width: 100%;
    height: 2.75rem;
    margin: 0;
    padding: 0 0.5rem 0 1.75rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.875rem;
    background: #f8fafc;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
  }

  .work-time-dd__value {
    display: block;
    width: 100%;
    height: 100%;
    line-height: 2.65rem;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e3a5f;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
  }

  .work-time-dd__value.is-placeholder {
    color: #94a3b8;
    font-weight: 500;
    font-size: 0.8rem;
  }

  .work-time-dd__icon {
    position: absolute;
    left: 0.55rem;
    top: 50%;
    width: 0.7rem;
    height: 0.7rem;
    margin-top: -0.35rem;
    pointer-events: none;
    background-color: transparent;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%232563eb'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .work-time-dd.is-open .work-time-dd__btn {
    background: #fff;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }

  .work-time-dd__menu {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 0.3rem);
    bottom: auto;
    z-index: 40;
    max-height: min(160px, 28vh);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 0.875rem;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);
    padding: 0.3rem;
  }

  .work-time-dd__option {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0.55rem 0.5rem;
    border: 0;
    border-radius: 0.6rem;
    background: transparent;
    color: #1e3a5f;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
  }

  .work-time-dd__option:hover,
  .work-time-dd__option.is-active {
    background: #eff6ff;
    color: #1d4ed8;
  }

  .work-dialog__backdrop {
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }

  .work-dialog {
    z-index: 999;
  }

  .work-dialog__panel {
    max-height: 92%;
    overflow: visible;
    padding-bottom: env(safe-area-inset-bottom, 0);
    will-change: transform;
    border-radius: 1rem;
  }

  @media (min-width: 640px) {
    .work-dialog__panel {
      border-radius: 1.5rem;
    }
  }

  .work-sheet-enter-active,
  .work-sheet-leave-active {
    transition: opacity 0.28s ease;
  }

  .work-sheet-enter-active .work-dialog__panel,
  .work-sheet-leave-active .work-dialog__panel {
    transition: transform 0.38s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .work-sheet-enter,
  .work-sheet-leave-to {
    opacity: 0;
  }

  .work-sheet-enter .work-dialog__panel,
  .work-sheet-leave-to .work-dialog__panel {
    transform: translateY(100%);
  }

  .work-sheet-enter-to .work-dialog__panel,
  .work-sheet-leave .work-dialog__panel {
    transform: translateY(0);
  }

  .work-dialog__actions {
    background: #fff;
    border-top: 1px solid #eef2f7;
    box-shadow: 0 -6px 16px rgba(15, 23, 42, 0.04);
    border-radius: 0 0 1rem 1rem;
  }

  @media (min-width: 640px) {
    .work-dialog__actions {
      border-radius: 0 0 1.5rem 1.5rem;
    }
  }

  .work-dialog__handle {
    width: 2.5rem;
    height: 0.25rem;
    border-radius: 9999px;
    background: #d1d5db;
    margin: 0.625rem auto 0.25rem;
  }

  .work-dialog__header {
    background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 55%, #1e3a8a 100%);
    border-radius: 1rem 1rem 0 0;
  }

  @media (min-width: 640px) {
    .work-dialog__header {
      border-radius: 1.5rem 1.5rem 0 0;
    }
  }

  .work-dialog__field {
    background: #fff;
    border: 1px solid #e8edf3;
    border-radius: 1rem;
    padding: 0.75rem;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: visible;
    position: relative;
    z-index: 1;
  }

  .work-dialog__field:has(.work-time-dd.is-open) {
    z-index: 5;
  }

  .work-dialog__field-label {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    margin-bottom: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #475569;
  }

  .work-dialog__textarea {
    width: 100%;
    padding: 0.75rem 0.875rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.875rem;
    font-size: 0.875rem;
    color: #1f2937;
    background: #f8fafc;
    resize: none;
    box-sizing: border-box;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  }

  .work-dialog__textarea:focus {
    outline: none;
    background: #fff;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }

  .work-dialog__textarea::placeholder {
    color: #94a3b8;
  }

  .work-dialog__submit {
    background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    box-shadow: 0 8px 20px rgba(29, 78, 216, 0.28);
  }

  .work-dialog__submit:hover:not(:disabled) {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  .work-dialog__submit:active:not(:disabled) {
    transform: translateY(0);
  }

  .work-dialog__spinner {
    width: 1rem;
    height: 1rem;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
    border-radius: 50%;
    animation: work-dialog-spin 0.7s linear infinite;
  }

  @keyframes work-dialog-spin {
    to { transform: rotate(360deg); }
  }

  .home-skeleton-group {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .home-skeleton-group::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.65) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: home-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .skeleton-block {
    background-color: #e5e7eb;
  }

  .skeleton-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .skeleton-line {
    border-radius: 6px;
  }

  .skeleton-line-md {
    width: 7rem;
    height: 0.875rem;
  }

  .skeleton-line-sm {
    width: 5.5rem;
    height: 0.75rem;
  }

  .skeleton-branch {
    width: 5rem;
    height: 2rem;
    border-radius: 0.375rem;
  }

  .skeleton-card {
    min-height: 4.75rem;
    border-radius: 0.75rem;
  }

  .skeleton-card-en {
    min-height: 6.5rem;
    border-radius: 0.5rem;
  }

  .home-work-btn {
    max-height: 3.5rem;
    min-height: 3rem;
  }

  .home-work-btn--active {
    max-height: none;
    min-height: 3.5rem;
    align-items: center;
  }

  .skeleton-work-btn {
    max-height: 3.5rem;
    min-height: 3rem;
    margin-top: 0.75rem;
    border-radius: 9999px;
    align-self: start;
  }

  .skeleton-version {
    width: 4.5rem;
    height: 0.75rem;
    border-radius: 6px;
  }

  @keyframes home-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
